import { Bar } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import React from 'react';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const getRandomColor = () => {
    const r = Math.floor(Math.random() * 256);
    const g = Math.floor(Math.random() * 256);
    const b = Math.floor(Math.random() * 256);
    return `rgba(${r}, ${g}, ${b}, 0.7)`;
};

const DiscountSummaryChart = ({ discountSummary }) => {
    const filteredData = (discountSummary || []).filter(
        d => d.total_discount_amount !== null && d.total_discount_amount !== undefined
    );

    const labels = filteredData.map(d => d.Discounts);
    const discountValues = filteredData.map(d => parseFloat(d.total_discount_amount));

    const backgroundColors = filteredData.map(() => getRandomColor());
    const borderColors = backgroundColors.map(c => c.replace(/0\.7/, '1'));

    const data = {
        labels,
        datasets: [
            {
                label: 'Total Discount Amount',
                data: discountValues,
                backgroundColor: backgroundColors,
                borderColor: borderColors,
                borderWidth: 1
            }
        ]
    };

    const options = {
        responsive: true,
        plugins: {
            legend: { display: false },
            title: {
                display: true,
                text: 'Total Discount by Type',
                font: { size: 16 }
            }
        },
        scales: {
            y: {
                beginAtZero: true,
                title: {
                    display: true,
                    text: 'Total Discount Amount',
                    color: '#4F5255',
                    font: { size: 13, weight: 'bold' }
                },
                ticks: {
                    font: { weight: 'bold' },
                    callback: (value) => value.toLocaleString()
                }
            },
            x: {
                ticks: {
                    display: true,
                    color: '#4F5255',
                    font: { weight: 'bold' }
                },
                title: {
                    display: true,
                    text: 'Discount Type',
                    color: '#4F5255',
                    font: { size: 13, weight: 'bold' }
                },
                grid: { display: false }
            }
        }
    };

    return (
        <div className='my-5'>
            <div className="h-[500px] px-16 flex justify-center">
                <Bar data={data} options={options} />
            </div>

            <div className="flex justify-end mt-2">
                <div className="inline-block">
                    <table className="text-xs">
                        <thead className="bg-gray-100">
                            <tr>
                                <th className="border px-2 py-1">Color</th>
                                <th className="border px-2 py-1">Discount Type</th>
                                <th className="border px-2 py-1">Total Discount Amount</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredData.map((item, idx) => (
                                <tr key={idx}>
                                    <td className="border px-2 py-1 text-center">
                                        <span
                                            style={{
                                                display: 'inline-block',
                                                width: '16px',
                                                height: '16px',
                                                backgroundColor: backgroundColors[idx],
                                                border: `1px solid ${borderColors[idx]}`,
                                                borderRadius: '3px'
                                            }}
                                        ></span>
                                    </td>
                                    <td className="border px-2 py-1 whitespace-nowrap">{item.Discounts}</td>
                                    <td className="border px-2 py-1 whitespace-nowrap">
                                        {parseFloat(item.total_discount_amount).toLocaleString()}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default DiscountSummaryChart;